import React, { useState } from "react";
import styles from "./About.module.css";

// Served from /public, not a JS module import — Vite doesn't bundle public/ assets.
const slideImage = "/images/slide1.jpg";

const numberStats = [
  { number: "11", label: "Units" },
  { number: "2", label: "Locations" },
  // { number: "60+", label: "Rooms" },
];

const About = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className={styles.aboutPage}>
      {/* OUR STORY SECTION */}
      <section className={styles.aboutOurStory}>
        <div className={styles.aboutTextContainer}>
          <h2 className={styles.sectionTitle}>OUR STORY</h2>
          <p>
            At Aurelia Hospitality, our journey began with a simple vision: to
            create a home away from home where luxury meets warmth. Founded with
            a passion for redefining hospitality, we set out to craft
            experiences that go beyond just accommodation offering comfort,
            elegance, and personalized service tailored to every guest. From our
            first boutique residence to our expanding portfolio of premium
            stays, our commitment has remained the same: to provide exceptional
            hospitality that leaves lasting memories. <br />
            Every detail, from the finest materials to the most personalized
            service, is carefully considered to ensure an atmosphere of
            refinement and exclusivity. Whether you're here to indulge, relax,
            or be inspired, Aurelia promises an experience that is both
            extraordinary and unforgettable.
          </p>
        </div>

        {/* Replaced About Stats with Animated Stats */}
        <div className={styles.animatedStatsContainer}>
          {numberStats.map((stat, index) => {
            const isHovered = hoveredIndex === index;
            const isOtherHovered = hoveredIndex !== null && !isHovered;

            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={[
                  styles.animatedStatItem,
                  isHovered ? styles.hovered : '',
                  isOtherHovered ? styles.otherHovered : '',
                  index === 1 ? styles.borderedStat : '',
                ].filter(Boolean).join(' ')}
              >
                <div>
                  <h1 className={styles.statNumber}>{stat.number}</h1>
                </div>
                {isHovered && <p className={styles.statLabel}>{stat.label}</p>}
              </div>
            );
          })}
        </div>
      </section>

      {/* FULL-WIDTH IMAGE */}
      <div className={styles.aboutFullWidthImage}>
        <img src={slideImage} alt="Interior view" />
      </div>

      {/* OUR PHILOSOPHY SECTION */}
      <section className={styles.aboutPhilosophy}>
        <div className={styles.aboutPhilosophyImage}>
          <img src={slideImage} alt="Smiling man" />
        </div>
        <div className={styles.aboutPhilosophyText}>
          <h2 className={styles.sectionTitle2}>OUR PHILOSOPHY</h2>
          <p>
            At Aurelia, we believe that finding a home, whether for a night, a
            month, or a lifetime should be more than just a transaction. It
            should be an experience of seamless luxury, refined comfort, and
            effluent elegance. We curate extraordinary residences in the world’s
            most desirable destinations, ensuring that each stay is defined by
            sophistication, exclusivity, and impeccable service.
          </p>
          <p>
            Our philosophy is simple. Luxury should be effortless. From booking
            to check-out, every detail is designed to provide an experience that
            is seamless, personal, and unforgettable. Whether you seek a
            tranquil retreat, a vibrant city escape, or a timeless sanctuary,
            Aurelia ensures that your residence is more than just a place to
            stay, it’s a place to belong.
          </p>
          <p>
            <em>
              Aurelia. Residences of distinction, experiences of a lifetime.
            </em>
          </p>
        </div>
      </section>

      {/* TAGLINE */}
      <div className={styles.aboutTagline}>
        <p className={styles.aboutTaglineStyle}>
          Welcome to Aurelia, where <strong>Prestige</strong>,{" "}
          <strong>Elegance</strong>, and <strong>Timeless beauty</strong> come
          to life.
        </p>
      </div>
    </div>
  );
};

export default About;
